import React from 'react';
import { Quote } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function OneLinersSection() {
  const {
    t
  } = useLanguage();
  const quotes = [t('oneliners.q1'), t('oneliners.q2'), t('oneliners.q3'), t('oneliners.q4'), t('oneliners.q5'), t('oneliners.q6'), t('oneliners.q7'), t('oneliners.q8'), t('oneliners.q9'), t('oneliners.q10')];
  return <section className="py-20 bg-white border-t border-black/5 overflow-hidden" data-id="element-258">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-259">
        <div className="text-center mb-16" data-id="element-260">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-black" data-id="element-261">
            {t('oneliners.title')}
          </h2>
        </div>

        {/* CSS Marquee / Grid fallback for quotes */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-262">
          {quotes.slice(0, 6).map((quote, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-brand-cream p-8 rounded-2xl border border-black/5 relative" data-id="element-263">
              <Quote className="absolute top-6 left-6 w-8 h-8 text-brand-gold/20 rotate-180" data-id="element-264" />
              <p className="text-lg font-serif font-medium text-brand-black leading-relaxed mt-6 relative z-10" data-id="element-265">
                "{quote}"
              </p>
            </motion.div>)}
        </div>

        {/* Hidden on mobile, shows rest of quotes on larger screens to fill grid nicely */}
        <div className="hidden lg:grid grid-cols-3 gap-6 mt-6" data-id="element-266">
          {quotes.slice(6, 9).map((quote, index) => <motion.div key={index + 6} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: (index + 6) * 0.1
        }} className="bg-brand-cream p-8 rounded-2xl border border-black/5 relative" data-id="element-267">
              <Quote className="absolute top-6 left-6 w-8 h-8 text-brand-gold/20 rotate-180" data-id="element-268" />
              <p className="text-lg font-serif font-medium text-brand-black leading-relaxed mt-6 relative z-10" data-id="element-269">
                "{quote}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}